import { useParams } from 'react-router-dom';

import PatientNotesTab from '~/components/maud/patients/profile/tabs/patientNotesTab/PatientNotesTab';

const NotesPage = () => {
  const { patientId } = useParams<{ patientId: string }>();

  if (!patientId) return null;

  return <PatientNotesTab patientId={patientId} />;
};

export default NotesPage;
